import { ACCOUNTING_PROVIDER_FLAGS } from '@neo.tax/shared/constants';
import { AccountingProvider } from '@neo.tax/shared/graphql';
import { useFlags } from '@neo.tax/shared/third-parties';

import { AccountingProviderCardProps } from '../connect-account.types';
import { toAccountingProviderCards } from '../connect-account.utils';
import { useAccountingProviderIds } from './useAccountingProviderIds';

export const useAccountingProviderCards = ({
  connectedProviders,
  enabled,
}: {
  enabled: boolean;
  connectedProviders: Set<AccountingProvider>;
}): AccountingProviderCardProps[] => {
  const accountingAccountIds = useAccountingProviderIds();
  const flags = useFlags();
  if (!enabled) return [];
  const accountingIds: {
    provider: AccountingProvider;
    analyticId: string;
    connected: boolean;
  }[] = [
    {
      provider: AccountingProvider.Quickbooks,
      analyticId: accountingAccountIds.quickbooksRadioId,
      connected: connectedProviders.has(AccountingProvider.Quickbooks),
    },
    {
      provider: AccountingProvider.Netsuite,
      analyticId: accountingAccountIds.netsuiteRadioId,
      connected: connectedProviders.has(AccountingProvider.Netsuite),
    },
    {
      provider: AccountingProvider.SelfReported,
      analyticId: accountingAccountIds.csvRadioId,
      connected: connectedProviders.has(AccountingProvider.SelfReported),
    },
  ].filter(({ provider }) => ACCOUNTING_PROVIDER_FLAGS[provider] && flags[ACCOUNTING_PROVIDER_FLAGS[provider]]);
  return toAccountingProviderCards(accountingIds);
};
